import axios from "axios";
import AuthService from "./services/AuthService";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    // TODO: decide if these are needed
    // "Access-Control-Allow-Origin": process.env.VUE_APP_BASE_URL,
    // "Access-Control-Allow-Methods": "POST", "GET", "DELETE"
  }
});


// Attach the current user's Firebase ID token (when logged in) to every request.
httpClient.interceptors.request.use(async (config) => {
  try {
    const token = await AuthService.getIdToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) {
    // Not logged in or token unavailable — proceed without the auth header.
  }
  return config;
});

// Retry failed requests that opted in via `{ retry: N, retryDelay: ms }` in their request config.
//
// Rules:
//  - Requests WITHOUT a `retry` option are never retried: the error is rejected straight away so
//    the caller's catch block runs. (Previously `undefined <= 1` was false, so such requests were
//    retried forever every 3 s — e.g. a 409 from /save-recording-metadata kept the upload dialog on
//    "Saving metadata..." indefinitely while hammering the backend.)
//  - When retries are exhausted the last error is rejected (not swallowed into `undefined`).
//  - 4xx responses are never retried: the request itself is wrong (401/403/404/409), so retrying
//    can't fix it. Only network errors and 5xx responses are retried.
httpClient.interceptors.response.use(undefined, (err) => {
  const config = err && err.config;
  const status = err && err.response && err.response.status;
  const retriesLeft = config ? Number(config.retry) : NaN;

  if (!config || !Number.isFinite(retriesLeft) || retriesLeft <= 1) {
    return Promise.reject(err);
  }
  if (status >= 400 && status < 500) {
    return Promise.reject(err);
  }

  config.retry = retriesLeft - 1;
  const delayRetryRequest = new Promise((resolve) => {
    setTimeout(resolve, config.retryDelay || 3000);
  });
  return delayRetryRequest.then(() => httpClient(config));
});

export default httpClient;